import { BrowserRouter, Route, Routes } from 'react-router';
import PublicLayout from '@/pages/_layouts/publicLayout/PublicLayout.tsx';
import Home from '@/pages/_layouts/home/Home.tsx';
import ForgotPassword from '@/pages/forgot-password/ForgotPassword.tsx';
import Login from '@/pages/login/Login.tsx';
import MFAPage from '@/pages/login/mfa/MFAPage.tsx';
import PartnerTokenExchange from '@/pages/partner-token-exchange/PartnerTokenExchange.tsx';
import Register from '@/pages/register/Register.tsx';
import ResetPassword from '@/pages/reset-password/ResetPassword.tsx';
import RoutesWrapper from '@/router/RoutesWrapper.tsx';
import RootErrorBoundary from '@/router/RootErrorBoundary.tsx';

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<RoutesWrapper />}
          errorElement={<RootErrorBoundary />}
        >
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="login/mfa" element={<MFAPage />} />
            <Route path="register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
            <Route
              path="oauth/partner-token-exchange"
              element={<PartnerTokenExchange />}
            />
          </Route>
        </Route>
        {/* TODO add private layout when implementing identity portal */}
        {/*<Route path="/portal" element={<PrivateLayout />}>*/}
        {/*</Route>*/}
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
